import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProgramService } from '../../services/program.service';
import { Program } from '../../interfaces/program.model';
import 'rxjs/add/operator/switchMap';
import { NavBarService } from 'app/services/nav-bar.service';

@Component({
  selector: 'app-finance-modal',
  templateUrl: './finance-modal.component.html',
  styleUrls: ['./finance-modal.component.scss'],
})
export class FinanceModalComponent implements OnInit {
  selectedTab: number = 1;
  program: any = {};
  texts: any;
  ready: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProgramService,
    private NavBarService: NavBarService
  ) {}

  ngOnInit() {
    this.route.parent.params
      .switchMap((params: Params) => this.service.getFullProgram(+params['id']))
      .subscribe(a => {
        this.program = a;
        if (a !== undefined) {
          this.texts = a.Teksten.Texts;

          this.ready = true;

          this.NavBarService.setData({
            title: `${this.program.Weergavenummer}. ${this.program.naam}`,
            color: this.program.Weergavenummer,
            crumbs: [
              {
                text: `${this.program.Weergavenummer}. ${this.program.naam}`,
                link: `/programma/${this.program.id}`,
                active: false
              }, {
                text: `Financiële verantwoording`,
                link: null,
                active: true
              }
            ]
          });
        }
      });
  }

  asCard(target: any) {
    const p = <Program>{
      id: 0,
      name: target.naam,
      number: target.Weergavenummer,
      realised: target.gerealiseerd,
      estimated: target.begroot,
      forecast: target.prognose,
      space: target.ruimte,
    };

    console.log(p);
    return p;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/finance-modal/finance-modal.component.ts